import { Keys } from "./en";

const translations: Record<Keys, string> = {
  "Display trade history on chart": "차트에서 거래 내역 표시",
  "Add markets to Favorites in the Markets Browser":
    "마켓 브라우저에서 마켓을 즐겨찾기에 추가하세요",
  "Log in": "로그인",
  "Export embedded wallet": "내장 지갑 내보내기",
  "Email or Social": "이메일 또는 소셜",
  "Failed to load balances": "잔액을 불러오지 못했습니다",
  "No balances": "잔액이 없습니다",
  "Verified Operator": "검증된 운영자",
  "Strategy": "전략",
  "Multi-Strategy": "다중 전략",
  "Master Vault": "주요 볼트",
  "Master Vault Details": "주요 볼트 세부 정보",
  "Annualized": "연간화",
  "Depositors": "입금자",
  "No trade history": "거래 내역이 없습니다",
  "Unwinding Progress": "청산 진행 상황",
  "What are Vaults?": "볼트란 무엇인가요?",
  "APR calculated as the Annualised 30-day Return":
    "APR는 연간 30일 수익률로 계산됩니다",
  "APR": "APR",
  "Initializing": "초기화 중",
  "Awaiting Deposit": "입금 대기 중",
  "Vault Age": "볼트 연령",
  "30D Return": "30일 수익률",
  "{{field}} must be greater than the minimum initial deposit of {{minInitialDeposit}}":
    "{{field}}는 {{minInitialDeposit}} 이상의 최소 초기 입금액이어야 합니다.",
  "Minimum deposit": "최소 입금액",
  "Withdrawal amount exceeds available vault shares":
    "출금 금액이 볼트의 사용 가능한 주식을 초과합니다.",
  "Deposit would exceed maximum vault TVL of {{maxTVL}}":
    "입금이 볼트의 최대 TVL {{maxTVL}}을 초과합니다.",
  "{{field}} is required": "{{field}}은 필수입니다.",
  "Lockup Remaining": "잠금 잔여",
  "{{days}}D": "{{days}}일",
  "<1>{{days}}</1> D": "<1>{{days}}</1>일",
  "<1>{{hours}}</1> H": "<1>{{hours}}</1>시",
  "<1>{{minutes}}</1> M": "<1>{{minutes}}</1>분",
  "Vault settings submitted": "볼트 설정 제출됨",
  "Vault settings updated": "볼트 설정 업데이트됨",
  "Vault Settings": "볼트 설정",
  "Vault not found": "볼트가 없음",
  "The owner receives a {{profitShare}} profit share.":
    "소유자는 {{profitShare}}의 수익을 공유받습니다.",
  "This vault is entirely owned by the community.":
    "이 볼트는 커뮤니티에 완전히 소유되어 있습니다.",
  "Withdraw from Vault submitted": "볼트에서 출금 제출됨",
  "Deposit to Vault submitted": "볼트에 입금 제출됨",
  "Unknown error. Try again.": "알 수 없는 오류. 다시 시도하세요.",
  "Vault Deposit": "볼트 입금",
  "Vault Withdrawal": "볼트 출금",
  "No Lockup": "잠금 없음",
  "Lockup period is not over yet": "잠금 기간이 아직 끝나지 않았습니다",
  "Protocol": "프로토콜",
  "24H": "24시간",
  "7D": "7일",
  "30D": "30일",
  "All": "전체",
  "You have no investments in vaults": "볼트에 투자한 내역이 없습니다",
  "Total Value": "총 가치",
  "Investments Made": "총 투자 횟수",
  "Operator": "운영자",
  "Manage Vault": "볼트 관리",
  "Switch to the operator account": "운영자 계정으로 전환",
  "Active": "활성",
  "My Vaults": "내 금고",
  "Closed": "폐쇄됨",
  "Deposited": "예치됨",
  "Lifetime ROI": "ROI 총계",
  "Owners Equity": "소유자 자본",
  "Top Trending": "인기 급상승",
  "Owner Share": "소유자 지분",
  "Vault Details": "볼트 상세정보",
  "Contract": "계약",
  "Withdraw from Vault": "볼트에서 출금",
  "Withdraw from Vault successful": "볼트에서 출금 성공",
  "Failed to withdraw from Vault": "볼트에서 출금 실패",
  "Name": "이름",
  "Deposit": "입금",
  "Tokens": "토큰",
  "Avg. Entry Price": "평균 진입 가격",
  "Current Price": "현재 가격",
  "P&L": "손익",
  "My Vault Deposit": "내 볼트 입금",
  "Vaults": "볼트",
  "Create": "생성",
  "Create My Vault": "내 볼트 생성",
  "Vault Name": "볼트 이름",
  "Vault Description": "볼트 설명",
  "Token Symbol": "토큰 심볼",
  "Deposit Amount": "입금 금액",
  "Vault description will be visible publicly and you will not be able to edit this later.":
    "볼트 설명은 공개적으로 표시되며 나중에 수정할 수 없습니다.",
  "Once created, deposit at least {{minDeposit}} USDC to activate the vault. At this moment, only the Max TVL can be changed later.":
    "한 번 생성되면 최소 {{minDeposit}} USDC를 입금하여 볼트를 활성화할 수 있습니다. 이 시점에서는 최대 TVL만 나중에 변경할 수 있습니다.",
  "Create Vault": "볼트 생성",
  "Profit Share": "수익 공유",
  "Lockup Period (Days)": "잠금 기간 (일)",
  "Vault was successfully created and is being initialized":
    "볼트가 성공적으로 생성되었으며 초기화 중입니다",
  "Failed to create a vault": "볼트 생성 실패",
  "Maximum TVL": "최대 TVL",
  "No limit": "제한 없음",
  "Vault Address": "볼트 주소",
  "Deposit to Vault successful": "볼트에 입금 성공",
  "Failed to deposit to Vault": "볼트에 입금 실패",
  "Deposit to Vault": "볼트에 입금",
  "Vault": "볼트",
  "Owner": "소유자",
  "Age": "나이",
  "Failed to load vaults": "볼트 로드 실패",
  "No vaults available": "사용 가능한 볼트 없음",
  "Performance": "성과",
  "Vault Value": "볼트 가치",
  "My Deposit": "내 입금",
  "Total P&L": "총 손익",
  "Protocol Vaults": "프로토콜 볼트",
  "User Vaults": "사용자 볼트",
  "No Data": "데이터 없음",
  "Last Month Return": "지난 달 수익률",
  "TVL": "TVL",
  "Total Earnings": "총 수익",
  "About": "소개",
  "Vault Stats": "볼트 통계",
  "My Stats": "내 통계",
  "Vault Contract": "볼트 계약",
  "Description": "설명",
  "Max Drawdown": "최대 손실폭",
  "Volume": "거래량",
  "All-Time P&L": "전체 기간 손익",
  "Days": "일",
  "Lockup Period": "잠금 기간",
  "Search Vaults": "볼트 검색",
  "Blog": "블로그",
  "Block Explorer": "블록 탐색기",
  "Close Vault": "볼트 닫기",
  "Close Vault successful": "볼트 닫기 성공",
  "You must close all open positions to close your Vault. Closed vaults cannot be reopened.":
    "볼트를 닫으려면 모든 열린 포지션을 닫아야 합니다. 닫힌 볼트는 다시 열 수 없습니다.",
  "Close My Vault": "내 볼트 닫기",
  "Failed to Close the Vault": "볼트 닫기 실패",
  "Only the Main Account can manage the vault":
    "메인 계정만 볼트를 관리할 수 있습니다",
  "Allocate Collateral": "담보 할당",
  "Switch to Main Account": "메인 계좌로 전환",
  "Switch to Account": "계좌로 전환",
  "You are currently trading in the {{market}} market.":
    "현재 {{market}} 시장에서 거래하고 있습니다.",
  "To start trading on Isolated Market you must Allocate Collateral from your Main Account and switch to this Market Account.":
    "격리 시장에서 거래를 시작하려면 메인 계좌에서 담보를 할당하고 이 마켓 계좌로 전환해야 합니다.",
  "To trade in this market, switch to the Main Account first.":
    "이 시장에서 거래하려면 먼저 메인 계좌로 전환하십시오.",
  "This account can only trade in the {{market}} market.":
    "이 계정은 {{market}} 시장에서만 거래할 수 있습니다.",
  "Isolated Market": "격리 시장",
  "This feature currently is still in Beta. Backup your Paradex Private Key for additional safety.":
    "이 기능은 현재 베타 버전입니다. 추가 안전을 위해 Paradex 개인 키를 백업하십시오.",
  "Deposit failed": "입금 실패",
  "Deposit in progress": "입금 진행 중",
  "External Account": "외부 계정",
  "Tx Hashes": "트랜잭션 해시",
  "Continue to {{bridge}}": "{{bridge}}로 이동하기",
  "By clicking Continue to {{bridge}}, you will be sent to {{bridge}} website to bridge your funds out of Paradex.":
    "{{bridge}}로 이동하기를 클릭하면, {{bridge}} 웹사이트로 이동하여 자금을 Paradex에서 출금할 수 있습니다.",
  "By clicking Continue to {{bridge}}, you will be sent to {{bridge}} website to bridge your funds to Paradex.":
    "{{bridge}}로 계속하기를 클릭하면, {{bridge}} 웹사이트로 이동하여 자금을 Paradex로 전송할 수 있습니다.",
  "Refer": "추천",
  "Address": "주소",
  "Date Joined": "가입일",
  "Referral Code": "추천 코드",
  "Volume Traded": "거래량",
  "Bridge": "Bridge",
  "Notional Value": "명목 가치",
  "Withdraw to": "으로 출금",
  "Deposit from": "에서 입금",
  "Position is already closed": "포지션은 이미 종료되었습니다",
  "Your Paradex L2 Address is NOT a Public Starknet Address. If you try to send funds to this address on Public Starknet via a cross chain bridge you risk losing your funds. <1>Read more</1>.":
    "당신의 Paradex L2 주소는 Public Starknet 주소가 아닙니다. 이 주소로 cross chain 브릿지를 통해 자금을 전송하면 귀하는 자금을 잃을 위험이 있습니다. <1>Read more</1>..",
  "{{chain}} Address": "{{chain}} 주소",
  "Copy Paradex Private Key": "Paradex 개인키 복사",
  "Your account will be liquidated if Margin Ratio reaches 100%":
    "증거금 비율이 100%에 도달하는 경우 포지션이 청산됩니다",
  "Liquidation": "청산",
  "Fee": "수수료",
  "Maker": "메이커",
  "Maker Score": "메이커 점수",
  "Maker XP Share": "메이커 XP 공유",
  "Fee XP Share": "수수료 XP 공유",
  "Fee XP": "수수료 XP",
  "Maker XP": "메이커 XP",
  "Liquidation {{side}} Fill": "청산 {{side}} 채우기",
  "Settings": "설정",
  "Market Score": "점수",
  "Season {{season}} (coming soon)": "시즌 {{season}} (곧 출시 예정)",
  "Confirm Buy": "매수 확인",
  "Confirm Sell": "매도 확인",
  "Other XP": "기타 XP",
  "Estimated Receivable Amount": "예상 수령 금액",
  "Socialized Loss active. Click to learn more.":
    "사회화된 손실 활성화. 자세히 알아보려면 클릭하세요.",
  "Analytics": "분석",
  "Sign In to see your account XP stats": "XP 현황을 확인하려면 로그인하세요.",
  "<1>Clock Is Out Of Sync</1> The clock on your device is out of sync. This may cause issues with the application. Please make sure your device clock is set to be auto. For more details please <2>see documentation</2>":
    "<1>시간이 동기화되지 않음</1> 이는 앱에 문제를 일으킬 수 있습니다. 설정창에서 시간이 자동으로 설정되어 있는지 확인하세요. 자세한 내용은 <2>문서</2>를 참조하세요",
  "Failed to fetch max withdrawable amount":
    "최대 출금 금액을 가져오지 못했습니다.",
  "It is not possible to withdraw more than your Max Withdrawable Amount.":
    "최대 출금 금액을 초과하여 출금할 수 없습니다.",
  "Max Withdrawable Amount": "최대 출금 금액",
  "XP Explainer": "XP 설명",
  "Pool": "Pool",
  "Quote Quality": "견적 품질",
  "Create Your Public Username": "Public Username 만들기",
  "Edit Your Public Username": "Public Username 편집",
  "You have been logged out.": "로그아웃되었습니다.",
  "Maker Volume Score": "Maker 거래량 점수",
  "Fee Score": "수수료 점수",
  "Score Share": "점수 공유",
  "Instrument Share": "거래 종목 공유",
  "XP": "XP",
  "Total XP": "총 XP",
  "24h Change": "24시간 변동",
  "Leaderboard": "리더보드",
  "Cancel": "취소",
  "Portfolio": "포트폴리오",
  "Trade": "거래",
  "Build": "빌드",
  "Referrals Explainer": "레퍼럴 설명",
  "How It Works": "작동 방식",
  "My Referrals": "내 레퍼럴 목록",
  "Your Referral Code": "내 레퍼럴 코드",
  "Affiliate Program": "제휴 프로그램",
  "Enrolled": "등록됨",
  "Traders Referred": "레퍼럴된 트레이더",
  "Referral Rewards": "레퍼럴 보상",
  "Referral XP": "레퍼럴 XP",
  "Invite Friends": "친구 초대",
  "Share": "공유",
  "Earn": "Earn",
  "Give": "Give",
  "Share your code to invite friends to join Paradex":
    "친구들을 Paradex에 초대하기 위해 코드를 공유하세요",
  "<1>{{amount}}</1> Fees": "수수료 <1>{{amount}}</1>",
  "You receive {{amount}} of the referred user's fees":
    "추천한 사용자의 수수료의 {{amount}}를 받습니다",
  "<1>{{amount}}</1> XP": "XP <1>{{amount}}</1>",
  "You receive {{amount}} of the referred user's XP":
    "추천한 사용자의 XP의 {{amount}}를 받습니다",
  "<1>{{amount}}</1> Discount": "<1>{{amount}}</1> 디스카운트",
  "Your friend receives {{amount}} discount on fees":
    "친구가 수수료에서 {{amount}} 할인을 받습니다",
  "Create and share your custom referral code":
    "사용자 정의 추천 코드를 만들고 공유하세요",
  "If you have a strong social media following (<1>{{followers}}+</1>), you may be eligible for our <2>VIP Affiliate Program</2> with higher commissions and XP.":
    "강력한 소셜 미디어 팔로워가 <1>{{followers}}+</1> 있는 경우, 우리의 <2>VIP 제휴 프로그램</2>에 참여할 자격이 있을 수 있습니다.",
  "You can track our <1>Affiliate Leaderboard</1> to see how you stack up.":
    "당신의 성과를 확인하려면 <1>제휴 리더보드</1>를 확인하세요.",
  "Apply": "신청",
  "Log in to see your Referral History.": "로그인하여 추천 내역을 확인하세요.",
  "Welcome to Paradex": "Paradex에 오신 것을 환영합니다",
  "Congrats! The referral code you used is now active! It means you can start enjoying a discount on your trading fees!":
    "축하합니다! 사용한 추천 코드가 이제 활성화되었습니다! 이제 거래 수수료에서 할인을 받을 수 있습니다!",
  "Congrats! The referral code <1>{{codeProvided}}</1> used is now active!":
    "축하합니다! 사용한 추천 코드 <1>{{codeProvided}}</1>가 이제 활성화되었습니다!",
  "Referral code not activated. The code can only be applied once during the initial onboarding.":
    "추천 코드가 활성화되지 않았습니다. 코드는 초기 온보딩 중 한 번만 적용할 수 있습니다.",
  "Referral code <1>{{codeProvided}}</1> not activated. You have already onboarded with <1>{{referredBy}}</1>.":
    "추천 코드 <1>{{codeProvided}}</1>가 활성화되지 않았습니다. 이미 <1>{{referredBy}}</1>로 온보딩되었습니다.",
  "Referral Code Applied": "레퍼럴 코드 적용됨",
  "You will receive <1>{{userAmount}}</1> of referred user's <1>fees</1> <2>and</2> <1>{{userAmountPoints}} XP</1>. They will receive a <1>{{friendAmount}}</1> discount.":
    "당신은 추천받은 사용자의 수수료의 <1>{{userAmount}}</1>과 <1>{{userAmountPoints}} XP</1>을 받게 됩니다. 그들은 <1>{{friendAmount}}</1> 할인을 받게 됩니다.",
  "Community": "커뮤니티",
  "Environments": "환경",
  "Language": "언어",
  "System Status": "시스템 상태",
  "Docs": "문서",
  "Code Samples": "코드 샘플",
  "More": "더보기",
  "Stats": "통계",
  "Join Discord": "디스코드 참여",
  "Notifications": "알림",
  "All caught up!": "모두 업데이트되었습니다!",
  "You have no new notifications": "새로운 알림이 없습니다",
  "Connect Wallet": "지갑 연결",
  "WalletConnect is taking too long to open. Please refresh the page and try again.":
    "WalletConnect가 열리는 데 너무 오래 걸립니다. 페이지를 새로고침하고 다시 시도해주세요.",
  "Unexpected error opening WalletConnect modal. Please refresh the page and try again.":
    "WalletConnect 모달을 열 때 예기치 않은 오류가 발생했습니다. 페이지를 새로고침하고 다시 시도해주세요.",
  "Connect your Wallet": "지갑을 연결하세요",
  "Link Wallet": "지갑 링크",
  "You will receive a signature request. Signing is free and will not send a transaction.":
    "서명 요청을 받게 됩니다. 서명은 무료이며 거래를 보내지 않습니다.",
  "Generate Paradex Chain wallet": "Paradex 체인 지갑 생성중",
  "Generating Paradex Chain wallet": "Paradex 체인 지갑 생성 중",
  "Paradex Chain wallet generated": "Paradex 체인 지갑 생성됨",
  "Verify that you own this wallet": "이 지갑을 소유하고 있는지 확인하십시오",
  "Remember Me": "자동 로그인",
  "Only use 'Remember Me' if you are using a secure device you own. Selecting this option can expose your information to  others if you are accessing this wallet from a public device.":
    "'자동 로그인'은 본인이 소유한 안전한 장치에서만 사용하세요. 이 옵션을 선택하면 공용 장치에서 이 지갑에 액세스할 때 정보가 타인에게 노출될 수 있습니다.",
  "Continue": "계속",
  "Disconnect Wallet": "지갑 연결 해제",
  "Disconnect": "연결 해제",
  "Account": "계정",
  "Username": "사용자 이름",
  "Edit": "편집",
  "Your username is now hidden. It is not visible to other users.":
    "사용자 이름이 이제 숨겨집니다. 다른 사용자에게 보이지 않습니다.",
  "Your username will be visible to other users unless you choose to hide it. You can always change it later.":
    "사용자 이름은 숨기기를 선택하지 않는 한 다른 사용자에게 표시됩니다. 나중에 언제든지 변경할 수 있습니다.",
  "Hide my Username": "사용자 이름 숨기기",
  "Save": "저장",
  "Username is required": "사용자 이름이 필요합니다",
  "Username must be between 5 and 20 characters":
    "사용자 이름은 5자 이상 20자 이하이어야 합니다",
  "Username can only contain letters and numbers":
    "사용자 이름은 문자와 숫자만 포함할 수 있습니다",
  "Wallets": "지갑",
  "Paradex Block Explorer": "Paradex 블록 탐색기",
  "Log out": "로그아웃",
  "No markets available": "사용 가능한 시장이 없습니다",
  "Last Price": "마지막 가격",
  "Open Interest": "미결제 계약",
  "24h Volume": "24시간 거래량",
  "Mark Price": "시장가",
  "Spot Price": "기초 자산 가격",
  "Eight hour funding rate that is continuously accrued on positions and settled upon any trade. If the funding rate is positive, longs pay shorts. If negative, shorts pay longs.":
    "포지션에 지속적으로 발생하고 어떤 거래에도 정산되는 8시간 자금 비율. 자금 비율이 양수이면 롱 포지션은 숏 포지션에게 지불합니다. 음수이면 숏 포지션은 롱 포지션에게 지불합니다.",
  "8h Funding": "Funding (8시간)",
  "Limit": "Limit",
  "Market": "Market",
  "Stop Limit": "Stop Limit",
  "Stop Market": "Stop Market",
  "Scaled Order": "Scaled Order",
  "Trigger Price": "Trigger Price",
  "Input Price": "입력 가격",
  "Position Mark Price": "포지션 시장가",
  "Amount": "금액",
  "Reduce Only": "Reduce Only",
  "Reduce Only will increase position": "Reduce Only는 포지션을 늘릴 것입니다",
  "Your order stays open until it is filled or you decide to cancel.":
    "주문이 체결되거나 취소하기로 결정할 때까지 주문이 계속 열려 있습니다.",
  "Your order gets filled right away, partially or fully, and whatever is left gets canceled instantly.":
    "주문이 즉시 부분적으로 또는 완전히 체결되며, 남은 부분은 즉시 취소됩니다.",
  "Conditional limit order that serves to add liquidity to the order book as a Maker order.":
    "메이커 주문으로 주문서에 유동성을 추가하는 조건부 한정 주문.",
  "Currently the fees are fixed and uniform across the platform. Maker {{makerFee}} / Taker {{takerFee}}":
    "현재 수수료는 플랫폼 전체에서 고정되고 일관되게 책정됩니다. 메이커 {{makerFee}} / 테이커 {{takerFee}}",
  "Value": "가치",
  "Buy": "매수",
  "BUY": "매수",
  "LONG": "LONG",
  "Sell": "매도",
  "SELL": "매도",
  "SHORT": "SHORT",
  "Order Notional": "주문 명목 가치",
  "Current Position": "현재 포지션",
  "Account Value": "계정 가치",
  "The total value of your account at current mark prices":
    "현재 마크 가격에 따른 계정의 총 가치",
  "Unrealized P&L": "미실현 손익",
  "Free Collateral": "사용 가능한 담보",
  "Account Leverage": "계정 레버리지",
  "Margin": "마진",
  "Margin Ratio": "증거금 비율",
  "Initial Margin": "초기 마진",
  "Maintenance Margin": "유지 마진",
  "Order Book": "주문장",
  "Trades": "거래",
  "Price": "가격",
  "Size": "크기",
  "Total": "총계",
  "Time": "시간",
  "Spread": "스프레드",
  "Positions": "포지션",
  "Open Orders": "미체결 주문",
  "Trade History": "거래 내역",
  "Order History": "주문 내역",
  "Funding Payments": "자금 지급",
  "Side": "측면",
  "Entry Price": "진입가",
  "Liquidation Price": "청산가",
  "Unrealized Funding": "미실현 펀딩비",
  "Close Position": "포지션 종료",
  "Market Close": "시장 마감",
  "Close Long": "롱 포지션 종료",
  "Close Short": "숏 포지션 종료",
  "Type": "유형",
  "Filled": "체결",
  "Triggered": "트리거됨",
  "Instruction": "지시",
  "Client Order Id": "클라이언트 주문 ID",
  "Status": "상태",
  "NEW": "새로운",
  "OPEN": "열림",
  "UNTRIGGERED": "트리거되지 않음",
  "CLOSED": "닫힘",
  "Pending": "대기 중",
  "Complete": "완료",
  "Completed": "완료됨",
  "Failed": "실패",
  "Bust": "폭파",
  "Notional / Fee": "명목가치 / 수수료",
  "Liquidity": "유동성",
  "Tx Hash": "Tx 해시",
  "Trade Id": "거래 ID",
  "Remaining": "남아있는",
  "Cancel Reason": "취소 이유",
  "User Canceled": "사용자가 취소함",
  "Not Enough Margin": "증거금 부족",
  "Empty Market": "빈 시장",
  "Post Only": "Post Only",
  "Post Only Would Cross": "Post Only는 교차 할 것입니다",
  "Remaining IOC Cancel": "남은 IOC 취소",
  "Unexpected Failure": "예기치 않은 실패",
  "Deleverage": "레버리지 감소",
  "In Liquidation": "청산 중",
  "Self Trade": "통정거래",
  "Asset Unavailable": "자산 사용 불가",
  "Asset Expired": "자산 만료",
  "Order Type Invalid": "유효하지 않은 주문유형",
  "Price Not Available": "가격 사용 불가",
  "Expired": "만료됨",
  "Exceeds Max Slippage": "최대 슬립페이지를 초과함",
  "Timeout": "시간 초과",
  "Order Exceeds Position Limit": "주문이 포지션 한도를 초과함",
  "Order Id": "주문 ID",
  "Payment": "결제",
  "Cancel All": "모두 취소",
  "{{orderSize}} will be closed at Market price":
    "{{orderSize}}는 시장 가격으로 체결됩니다",
  "By connecting a wallet, you agree to <1>Paradex Terms of Service</1> and represent and warrant to Paradex that you are not a <2>Restricted Person</2>.":
    "지갑을 연결함으로써, 당신은 <1>Paradex 이용 약관</1>에 동의하며, Paradex에게 당신이 <2>제한된 사람</2>이 아님을 보증합니다.",
  "Wallet": "지갑",
  "Deposit_verb": "예금하다",
  "Deposit_noun": "예금",
  "Withdraw": "인출하다",
  "Withdrawal": "인출",
  "Transfers": "전송",
  "Transfer": "전송",
  "Collateral": "담보",
  "Asset": "자산",
  "Wallet Balance": "지갑 잔액",
  "Actions": "행동",
  "Action": "행동",
  "External Tx Hash": "외부 Tx 해시",
  "Withdraw to Wallet": "지갑으로 출금",
  "Deposit to Paradex": "Paradex로 입금",
  "You have no balance in your Ethereum wallet. Deposit some {{asset}} and try again.":
    "당신의 이더리움 지갑에 잔액이 없습니다. {{asset}}을 입금하고 다시 시도해보세요.",
  "It is not possible to deposit more than your current balance.":
    "현재 잔액보다 많이 입금할 수는 없습니다.",
  "Available": "사용 가능",
  "Initiate a deposit from your Ethereum wallet to the Paradex bridge. These transactions":
    "이더리움 지갑에서 Paradex 브리지로 입금을 시작하세요. 이러한 거래",
  "Initiate a deposit from your Ethereum wallet to the Paradex bridge. These transactions may take several minutes depending on network conditions. For more information check out our <1>docs</1>.":
    "이더리움 지갑에서 Paradex 브리지로 입금을 시작하세요. 이러한 거래는 네트워크 상태에 따라 몇 분이 걸릴 수 있습니다. 자세한 정보는 <1>문서</1>를 확인하세요.",
  "read more": "더 읽기",
  "Initiate Deposit to Bridge": "브릿지로 입금 시작",
  "Enable USDC on Paradex": "Paradex에서 USDC 활성화",
  "In order to deposit you must allow Paradex access to at least {{amount}}.":
    "입금하기 위해서는 Paradex가 최소 {{amount}}에 접근할 수 있도록 허용해야 합니다.",
  "Enable USDC": "USDC 활성화",
  "Withdraw initiated": "출금 시작됨",
  "Withdrawals are a two-step process. First initiate a withdrawal from Paradex":
    "출금은 두 단계의 과정입니다. 먼저 Paradex에서 출금을 시작하세요",
  "Withdrawals are a two-step process. First initiate a withdrawal from Paradex to the Paradex Bridge. This first step can take 5-16 hours (10 on average). Second, initiate your withdrawal from the Paradex Bridge to your Ethereum wallet via the Deposits / Withdrawals table. For more information check out our <1>docs</1>.":
    "출금은 두 단계의 과정입니다. 먼저 Paradex에서 Paradex 브리지로 출금을 시작합니다. 이 첫 번째 단계는 5-16시간이 걸릴 수 있습니다 (평균 10개). 두 번째로, 입금 / 출금 테이블을 통해 Paradex 브리지에서 이더리움 지갑으로 출금을 시작합니다. 자세한 정보는 우리의 <1>문서</1>를 확인하세요.",
  "Initiate Withdrawal to Bridge": "브릿지로 출금 시작",
  "You have no funds to withdraw. It is not possible to withdraw more than your free collateral.":
    "출금할 자금이 없습니다. 사용 가능한 담보보다 많이 출금할 수는 없습니다.",
  "It is not possible to withdraw more than your free collateral.":
    "사용 가능한 담보보다 많이 출금할 수는 없습니다.",
  "You have no collateral": "담보가 없습니다",
  "You have no open positions": "열린 포지션이 없습니다",
  "You have no open orders": "열린 주문이 없습니다",
  "You have no trades": "거래가 없습니다",
  "You have no orders": "주문이 없습니다",
  "You have no funding payments": "자금 지급이 없습니다",
  "You have no transfers": "전송이 없습니다",
  "Account in liquidation": "청산이 진행중인 계정",
  "Account is being liquidated. Any open positions will be reduced. Trading now is disabled.":
    "계정이 청산 중입니다. 모든 열린 포지션은 감소됩니다. 현재 거래가 비활성화되었습니다.",
  "Account liquidated": "계정 청산됨",
  "Your account was liquidated on {{createdAt}}. Any open positions were reduced.":
    "{{createdAt}}에 계정이 청산되었습니다. 모든 열린 포지션은 감소되었습니다.",
  "Deposit to Paradex successful": "Paradex로의 입금 성공",
  "Deposit to Paradex failed": "Paradex로의 입금 실패",
  "Unexpected error. Try again.": "예상치 못한 오류. 다시 시도해보세요.",
  "Deposit initiated": "입금 시작됨",
  "Deposit to bridge initiated": "브리지로의 입금 시작됨",
  "Deposit to Paradex available": "Paradex로 입금 가능",
  "Go to Deposits": "입금으로 이동",
  "Deposit to Paradex in progress": "Paradex로의 입금 진행 중",
  "Transfer successful": "전송 성공",
  "Limit {{side}} Order Fill": "제한 {{side}} 주문 채우기",
  "{{type}} {{side}} Order Submitted": "{{type}} {{side}} 주문 제출됨",
  "{{type}} {{side}} Order Canceled": "{{type}} {{side}} 주문 취소됨",
  "Reason": "이유",
  "Market {{side}} Order Fill": "시장 {{side}} 주문 채우기",
  "Trade Busted On-Chain": "체인에서 거래 실패",
  "Fill id": "채우기 id",
  "Withdraw to wallet failed": "지갑으로의 출금 실패",
  "Withdrawal to bridge initiated": "브리지로의 출금 시작됨",
  "Withdrawal error. Try again.": "출금 오류. 다시 시도해보세요.",
  "Withdrawal to bridge in progress": "브리지로의 출금 진행 중",
  "Withdrawal to wallet initiated": "지갑으로의 출금 시작됨",
  "Withdrawal to bridge failed": "브리지로의 출금 실패",
  "Transaction error. Try again.": "거래 오류. 다시 시도해보세요.",
  "Withdrawal to wallet available": "지갑으로 출금 가능",
  "Go to Withdrawals": "출금으로 이동",
  "Withdrawal to wallet successful": "지갑으로의 출금 성공",
  "Session expired, please log in again.":
    "세션이 만료되었습니다, 다시 로그인해주세요.",
  "Failed to submit order": "주문 제출 실패",
  "Your username preferences were updated!":
    "사용자 이름 선호 설정이 업데이트되었습니다!",
  "Unexpected error updating username preferences":
    "사용자 이름 선호 설정 업데이트 중 예상치 못한 오류",
  "This username already exists. Please choose a different username and try again.":
    "이 사용자 이름은 이미 존재합니다. 다른 사용자 이름을 선택하고 다시 시도해주세요.",
  "Validation Error": "검증 오류",
  "Binding Error": "바인딩 오류",
  "Internal Error": "내부 오류",
  "Not Found": "찾을 수 없음",
  "Service Unavailable": "서비스를 사용할 수 없음",
  "Invalid Request Parameter": "잘못된 요청 매개변수",
  "Order Id Not Found": "주문 Id를 찾을 수 없음",
  "Order Is Closed": "주문이 종료됨",
  "Order Is Not Open Yet": "주문이 아직 열리지 않음",
  "Client Order Id Not Found": "클라이언트 주문 Id를 찾을 수 없음",
  "Duplicated Client Id": "중복된 클라이언트 Id",
  "Invalid Price Precision": "잘못된 가격 정밀도",
  "Invalid Token": "잘못된 토큰",
  "Invalid Ethereum Address": "잘못된 이더리움 주소",
  "Blocked Ethereum Address": "차단된 이더리움 주소",
  "Invalid Ethereum Signature": "잘못된 이더리움 서명",
  "Invalid Starknet Address": "잘못된 Starknet 주소",
  "Invalid Starknet Signature": "잘못된 Starknet 서명",
  "Starknet Signature Verification Failed": "Starknet 서명 검증 실패",
  "Bad Starknet Request": "잘못된 Starknet 요청",
  "Ethereum Signer Mismatch": "이더리움 서명자 불일치",
  "Ethereum Hash Mismatch": "이더리움 해시 불일치",
  "Not Onboarded": "온보딩되지 않음",
  "Invalid Timestamp": "잘못된 타임스탬프",
  "Invalid Signature Expiration": "잘못된 서명 만료",
  "Account Not Found": "계정을 찾을 수 없음",
  "Invalid Order Signature": "잘못된 주문 서명",
  "Public Key Invalid": "공개 키가 유효하지 않음",
  "Unauthorized Ethereum Address": "인증되지 않은 이더리움 주소",
  "Ethereum Address Already Onboarded": "이미 온보딩된 이더리움 주소",
  "Market Not Found": "마켓을 찾을 수 없음",
  "Allowlist Entry Not Found": "허용 목록 항목을 찾을 수 없음",
  "Username In Use": "사용 중인 사용자 이름",
  "Service access restricted in your region":
    "귀하의 지역에서 서비스 접근이 제한됨",
  "No Access Allowed": "접근이 허용되지 않음",
  "You do not have access to the platform. Please join our Discord to get access.":
    "플랫폼에 접근할 수 없습니다. 접근하려면 우리의 디스코드에 가입해주세요.",
  "{{actualChainName}} Wallet Connected": "이더리움 지갑 연결됨",
  'Incorrect network selected "{{actualChainName}}". Please change the network to "{{requiredChainName}}" (id={{requiredChainId}}) in your wallet and retry.':
    '잘못된 네트워크 선택 "{{actualChainName}}". 지갑에서 네트워크를 "{{requiredChainName}}" (id={{requiredChainId}})으로 변경하고 다시 시도해주세요.',
  "Choose Wallet": "지갑 선택",
  "Starknet Wallet": "Starknet 지갑",
  "Switch to {{env}}": "{{env}}로 전환",
  "Search": "검색",
  "League": "리그",
  "Switch Account": "계정 전환",
  "Rank": "순위",
  "24h XP": "24시간 XP",
  "XP Per Day": "하루 평균 XP",
  "Season Volume": "시즌 거래량",
  "Lifetime Volume": "평생 거래량",
  "Pre-Season": "프리시즌",
  "Earn More XP": "더 많은 XP를 얻으세요",
  "XP Boost": "XP 부스트",
  "XP Drop": "XP 드롭",
  "Trader": "트레이더",
  "Total Share": "총 공유",
  "Maker Share": "메이커 공유",
  "Maker Volume Share": "메이커 거래량 공유",
  "Fee Share": "수수료 공유",
  "Fee Volume Share": "수수료 거래량 공유",
  "No data available": "사용 가능한 데이터가 없습니다",
  "Refer & Earn": "추천하고 수익 창출",
  "Hours": "시간",
  "Minutes": "분",
  "Time/Duration": "시간/기간",
  "Runtime": "실행 시간",
  "Frequency": "빈도",
  "Number of Orders": "주문 수",
  "Runtime should not be empty": "실행 시간이 비어 있어서는 안 됩니다",
  "Runtime should be less than or equal to 24 hours":
    "실행 시간은 24시간 이하거나 같아야 합니다",
  "Inactive": "비활성",
  "Avg. Price": "평균 가격",
  "The minimum required amount for {{numOrders}} orders is {{totalSize}} {{currency}}.":
    "{{numOrders}} 주문에 대한 최소 요구 금액은 {{totalSize}} {{currency}}입니다.",
  "Take Profit / Stop Loss: Set take profit and stop loss price levels to automate trade actions. When the Mark Price will reach the price you set, it will send your order to the matching engine.":
    "이익 실현/손절매: 거래 작업을 자동화하기 위해 이익 실현 및 손절매 가격 수준을 설정하세요. 설정한 가격에 도달하면 주문이 매칭 엔진으로 전송됩니다.",
  "When Mark Price reaches <1 />, it will trigger <2 /> order to close the selected amount with an estimated profit of <3 />.":
    "마크 가격이 <1 />에 도달하면 <2 /> 주문이 실행되어 선택한 금액을 예상 이익 <3 />으로 마감합니다.",
  "When Mark Price reaches <1 />, it will trigger <2 /> order to close the selected amount with an estimated loss of <3 />.":
    "마크 가격이 <1 />에 도달하면 <2 /> 주문이 실행되어 선택한 금액을 예상 손실 <3 />으로 마감합니다.",
  "Edit TP/SL For This Position": "이 포지션의 TP/SL 편집",
  "Take Profit": "테이크 프로핏",
  "Profit": "이익",
  "Stop Loss": "스톱 로스",
  "Loss": "손실",
  "Confirm": "확인",
  "Take Profit Limit": "테이크 프로핏 지정가",
  "Take Profit Market": "테이크 프로핏 시장가",
  "Stop Loss Limit": "스톱 로스 지정가",
  "Stop Loss Market": "스톱 로스 시장가",
  "Funding": "자금 조달",
  "Unwinding": "청산",
  "Cancel TP/SL orders": "TP/SL 주문 취소",
  "TP/SL orders submitted successfully.": "TP/SL 주문 제출 성공.",
  "Pre-Season + All Seasons": "프리시즌 + 모든 시즌",
  "Season {{season}}": "시즌 {{season}}",
  "XP Season {{season}}": "시즌 {{season}} XP",
  "Slippage": "슬리피지",
  "Max Slippage": "최대 슬리피지",
  "Max slippage defines the largest acceptable price deviation from the mark price.":
    "최대 슬리피지는 마크 가격에서 허용 가능한 가장 큰 가격 편차를 정의합니다.",
  "During execution, the order can be canceled if the price exceeds the slippage limit or falls outside the Market <1>Price Band</1>.":
    "실행 중에 가격이 슬리피지 한도를 초과하거나 시장 <1>가격 밴드</1>를 벗어나면 주문이 취소될 수 있습니다.",
  "Update Max Slippage": "최대 슬리피지 업데이트",
  "The Maximum Slippage allowed for {{symbol}} is {{price_band_width}}.":
    "{{symbol}}에 대한 허용 최대 슬리피지는 {{price_band_width}}입니다.",
  "Mark IV": "Mark IV",
  "Delta": "Delta",
  "Failed to load positions": "Failed to load positions",
  "No open positions": "No open positions",
  "learn more": "learn more",
  "Learn More": "Learn More",
  "Search Markets": "Search Markets",
  "Futures": "Futures",
  "Options": "Options",
  "OI": "OI",
  "My Profile": "내 프로필",
  "Addresses": "주소",
  "Chart": "차트",
  "ROI": "ROI",
  "Sharpe": "샤프",
  "Max Loss": "최대 손실",
  "Total Volume": "총 거래량",
  "My NFTs": "내 NFT",
  "My XP": "내 XP",
  "Balances": "잔고",
  "Other": "기타",
  "Paradex XP: Pre-Season": "Paradex XP: 프리시즌",
  "Paradex XP: Season {{season}}": "Paradex XP: 시즌 {{season}}",
  "Season {{season}} XP": "시즌 {{season}} XP",
  "Refer your friends to earn 10%": "친구를 추천하여 10%를 얻으세요",
  "Refer Friends and Earn 10%": "친구를 추천하여 10%를 얻으세요",
  "Invest in Paradex Vault & Earn 3X Boost":
    "Paradex Vault에 투자하여 3X 부스트를 얻으세요",
  "Avg. Daily XP": "평균 일일 XP",
  "Lifetime XP": "생명 주기 XP",
  "My Rank": "내 순위",
  "What is XP?": "XP란 무엇인가요?",
  "XP History": "XP 기록",
  "Last Week XP": "지난 주 XP",
  "TVL XP": "TVL XP",
  "OI XP": "OI XP",
  "Liquidation XP": "Liquidation XP",
  "Vaults XP": "Vaults XP",
  "Week": "주",
  "Season": "시즌",
  "Last updated: {{timestamp}}": "최근 업데이트: {{timestamp}}",
  "Xperience Points (XP)": "경험 포인트 (XP)",
  "Log in to see your XP balance": "로그인하여 XP 잔액을 확인하세요",
  "Log in to see where you stand": "로그인하여 어디에 있는지 확인하세요",
  "Connect your X account to join Pro League":
    "X 계정을 연결하여 프로 리그에 참여하세요",
  "Avg. Fill Price": "평균 체결 가격",
  "Spot": "현물",
  "Derivatives": "파생상품",
  "P&L Chart": "P&L 차트",
  "Account Value Chart": "계정 가치 차트",
  "Funding History": "자금 조달 기록",
  "Manage Funds": "자금 관리",
  "Profile": "프로필",
  "Community XP": "커뮤니티 XP",
  "XP Share": "XP 공유",
  "Next XP Drop in": "다음 XP 드롭까지",
  "In Progress": "진행 중",
  "{{field}} must be greater than {{value}}":
    "{{field}}은 {{value}}보다 커야 합니다",
  "{{field}} must be less than {{value}}":
    "{{field}}은 {{value}}보다 작아야 합니다",
  "Enter a valid Take Profit or Stop Loss price":
    "유효한 익절 또는 손절 가격을 입력하세요",
  "Take Profit and Stop Loss prices cannot be the same":
    "익절 가격과 손절 가격은 동일할 수 없습니다",
  "Breakeven Price": "손익분기점 가격",
  "Automatic Withdrawal": "자동 출금",
  "Estimated Gas Fee": "추정 가스 수수료",
  "Auto Withdrawal": "자동 출금",
  "Withdrawing...": "출금 중...",
  "Paradex Bridge withdrawals can take between 5-16 hours to complete":
    "Paradex Bridge 출금은 5-16시간 정도 걸릴 수 있습니다",
  "Socialized Loss": "소시아라이즈드 손실",
  "Receivable Amount": "받을 수 있는 금액",
  "Auto withdrawing...": "자동 출금 중...",
  "Manage Twitter Connection": "Twitter 연결 관리",
  "Unlock additional functionality.": "추가 기능 잠금 해제.",
  "Please note this connection can't be used as a login method to Paradex.":
    "이 연결은 Paradex의 로그인 방법으로 사용할 수 없습니다.",
  "Toast Notifications": "토스트 알림",
  "Display toast notifications": "토스트 알림 표시",
  "Average Entry Price": "평균 입금 가격",
  "Display average entry price line on chart":
    "평균 입금 가격 선을 차트에 표시",
  "Display liquidation price line on chart": "청산 가격 선을 차트에 표시",
  "Display open order lines on chart": "오픈 주문 선을 차트에 표시",
  "Failed to disconnect Twitter": "Twitter 연결 끊기 실패",
  "Failed to authorize Twitter": "Twitter 인증 실패",
  "Twitter account linked successfully!": "Twitter 계정 연결 성공!",
  "Failed to link twitter account": "Twitter 계정 연결 실패",
  "Fees": "수수료",
  "Taker pays {{takerFee}} in fees. Maker receives {{makerRebate}} in rebates.":
    "Taker는 {{takerFee}}의 수수료를 지불하고 Maker는 {{makerRebate}}의 리베이트를 받습니다.",
  "Manage Discord Connection": "Discord 연결 관리",
  "Failed to authorize Discord": "Discord 인증 실패",
  "Discord account linked successfully!": "Discord 계정 연결 성공!",
  "Failed to link Discord account": "Discord 계정 연결 실패",
  "Failed to disconnect Discord": "Discord 연결 끊기 실패",
  "Connect": "연결",
  "Unrealized P&L from current vault token balance. This doesn't account for owner profit share or slippage from positions unwind.":
    "현재 바렛 토큰 잔액의 미실현 P&L. 소유자의 이익 공유 또는 포지션 해제에 의한 슬리피지는 계산되지 않습니다.",
  "Show P&L Amount": "P&L 금액 표시",
  "Receivable amount must be positive": "받을 수 있는 금액은 양수여야 합니다",
  "Wallet Address Change Detected": "지갑 주소 변경 감지됨",
  "You can proceed with connecting your Paradex account to this wallet address or continue using your current connection.":
    "이 지갑 주소에 Paradex 계정을 연결하거나 현재 연결을 계속 사용할 수 있습니다.",
  "Connect To New Wallet": "새 지갑에 연결",
  "Keep Using Current Wallet": "현재 지갑 계속 사용",
  "Connect Current Wallet": "현재 지갑 연결",
  "The account is not connected. Please make sure that <1>{{walletAddress}}</1> is connected and is the active account in your <2>{{walletName}}</2> wallet.":
    "계정이 연결되지 않았습니다. <1>{{walletAddress}}</1>가 연결되어 있고 <2>{{walletName}}</2> 지갑에서 활성 계정인지 확인하세요.",
  "Reconnecting": "다시 연결 중",
  "There is a request in progress. Please proceed in your wallet.":
    "요청이 진행 중입니다. 지갑에서 계속 진행하세요.",
  "Modify Order": "주문 수정",
  "Realized P&L": "실현된 P&L",
  "Close All": "모두 닫기",
  "Close All Positions": "모든 포지션 닫기",
  "Market Close All Positions": "모든 포지션 시장가 청산",
  "Close {{percent}}% of All Positions": "모든 포지션을 {{percent}}% 닫기",
  "Failed to close all positions": "모든 포지션을 닫는 데 실패했습니다",
  "Number of Positions": "포지션 수",
  "Markets": "시장",
  "Position Value (Closing)": "포지션 가치 (닫기)",
  "{{count}} positions will be rounded to the nearest order increment":
    "{{count}} 포지션이 가장 가까운 주문 증가에 반올림됩니다",
  "You will earn Bonus XP on your referral activity":
    "추천 활동을 통해 보너스 XP를 얻을 수 있습니다",
  "Token Price": "토큰 가격",
  "Vault Token Price Chart": "Vault 토큰 가격 차트",
  "Market Close Orders Submitted": "시장이 모든 주문을 닫습니다",
  "This profile is already linked to a different Paradex account. Disconnect socials from existing account and try again.":
    "이 프로필은 이미 다른 Paradex 계정에 연결되어 있습니다. 기존 계정의 소셜 네트워크를 끊고 다시 시도하세요.",
  "XP Drops every Friday": "XP는 매주 금요일에 떨어집니다",
  "No XP Data Available": "XP 데이터가 없습니다",
  "XP data is available only for the Main Account.":
    "XP 데이터는 메인 계정에만 사용할 수 있습니다.",
  "Please switch to your Main Account to view your XP.":
    "메인 계정으로 전환하여 XP를 확인하세요.",
  "Referrals Not Available": "추천 불가",
  "Referrals are available only for the Main Account.":
    "추천은 메인 계정에만 사용할 수 있습니다.",
  "Please switch to your Main Account to view your Referrals.":
    "메인 계정으로 전환하여 추천을 확인하세요.",
  "Deposit initiated via Layerswap": "Layerswap 경유 입금 시작됨",
  "Position History": "포지션 내역",
  "Avg. Close Price": "평균 청산 가격",
  "Max Size": "최대 크기",
  "Closed Size": "청산된 크기",
  "Opened": "열림",
  "You have no positions": "보유한 포지션이 없습니다",
  "Destination Address": "목적지 주소",
  "Withdrawal via Layerswap initiated": "Layerswap 경유 출금 시작됨",
  "Withdrawal via Layerswap failed": "Layerswap 경유 출금 실패",
  "Market Share": "시장 점유율",
  "Tier": "티어",
  "Avg Maker Volume": "평균 Maker 거래량",
  "Liquidity Score": "리퀘스트 스코어",
  "Reward Share": "리워드 공유",
  "Enter amount": "금액 입력",
  "When Mark Price reaches <1 />, it will trigger <2 /> order to close the selected amount at <3 /> with an estimated profit of <4 />.":
    "마크 가격이 <1 />에 도달하면 <2 /> 주문이 실행되어 선택된 금액을 <3 />에서 닫고 예상 이익은 <4 />입니다.",
  "When Mark Price reaches <1 />, it will trigger <2 /> order to close the selected amount at <3 /> with an estimated loss of <4 />.":
    "마크 가격이 <1 />에 도달하면 <2 /> 주문이 실행되어 선택된 금액을 <3 />에서 닫고 예상 손실은 <4 />입니다.",
  "Limit Price": "지정가",
  "Delete": "삭제",
  "Use other bridges from the list above to withdraw funds much faster.":
    "위 목록에서 다른 브리지를 사용하여 자금을 더 빠르게 출금하세요.",
  "Paradex Chain Monitor": "Paradex 체인 모니터",
  "OTM Amount": "OTM 금액",
  "Leverage": "레버리지",
  "Strikes": "스트라이크",
  "Strike": "스트라이크",
  "Change": "변경",
  "Dist. to Spot": "스팟까지 거리",
  "Bid": "매수",
  "Mark": "마크",
  "Ask": "매도",
  "IV": "IV",
  "Dist %": "거리 %",
  "Call": "콜",
  "Put": "풋",
  "Mark Price / IV": "마크 가격 / IV",
  "8h F-Funding": "8시간 F-펀딩",
  "No Strikes Available": "사용 가능한 스트라이크 없음",
  "Attributes": "속성",
  "Why no Expiries?": "만료가 없는 이유는?",
  "{{multiplier}}x Boost": "{{multiplier}}배 부스트",
  "Like perpetual futures, perpetual options have no expiration, offering continuous exposure to the underlying asset with built-in downside protection. This gives users the flexibility to hold their position indefinitely and decide the optimal time to close it based on their strategy":
    "영구 선물과 마찬가지로, 영구 옵션은 만료가 없으며 내장된 하방 보호와 함께 기초 자산에 대한 지속적인 노출을 제공합니다. 이를 통해 사용자는 무기한으로 포지션을 유지하고 전략에 따라 최적의 종료 시기를 결정할 수 있는 유연성을 얻습니다",
  "Implied Volatility used to calculate the option's Mark Price":
    "옵션의 마크 가격을 계산하는 데 사용되는 내재 변동성",
  "Distance between the Strike Price and the underlying Spot Price":
    "스트라이크 가격과 기초 스팟 가격 간의 거리",
  "Eight hour funding that is continuously accrued on positions and settled upon any trade. If the funding rate is positive, longs pay shorts. If negative, shorts pay longs":
    "포지션에 지속적으로 발생하고 거래 시 정산되는 8시간 펀딩. 펀딩률이 양수이면 롱이 숏에게 지불하고, 음수이면 숏이 롱에게 지불합니다",
  "The Leverage Ratio (Lambda) measures an option's effective leverage by indicating how much the option's value changes, in percentage terms, for a 1% change in the spot price of the underlying asset. For example, if an option has a Lambda of 50 and the spot price increases by 1%, the option's value would increase by 50%":
    "레버리지 비율(람다)은 기초 자산의 스팟 가격이 1% 변동할 때 옵션 가치의 변동 비율을 나타내어 옵션의 실효 레버리지를 측정합니다. 예를 들어, 옵션의 람다가 50이고 스팟 가격이 1% 상승하면 옵션 가치는 50% 상승합니다",
  "Option delta measures how much the price of an option is expected to change for a $1 change in the price of the underlying asset. For example, a delta of 0.5 means the option price will move $0.50 for every $1 move in the underlying":
    "옵션 델타는 기초 자산 가격이 1달러 변동할 때 옵션 가격의 예상 변동액을 측정합니다. 예를 들어, 델타가 0.5이면 기초 자산이 1달러 움직일 때마다 옵션 가격은 0.50달러 움직입니다",
  "Eight hour funding rate of the perpetual future on the same underlying asset":
    "동일한 기초 자산의 영구 선물에 대한 8시간 펀딩률",
  "Having trouble? Try signing out and connecting again.":
    "문제가 있나요? 로그아웃하고 다시 연결해 보세요.",
  "API Reference": "API 참조",
  "XP Distribution occurs once per week on Friday at ~12 PM UTC":
    "XP 분배는 매주 금요일 UTC 오후 12시경에 발생합니다",
  "What are Perpetual Options?": "영구 옵션이란?",
  "Delta represents the increase in option price based on a $1 increase in the underlying spot price.\n\nFor example, a delta of 0.50 means the price of the option is expected to increase by $0.50 for a $1 increase in the underlying spot price.":
    "델타는 기초 스팟 가격이 1달러 상승할 때 옵션 가격의 상승을 나타냅니다.\n\n예를 들어, 델타가 0.50이면 기초 스팟 가격이 1달러 상승할 때 옵션 가격이 0.50달러 상승할 것으로 예상됩니다.",
  "Leverage(Lambda) represents the percentage change in option price for a 1% change in the underlying spot price.\n\nFor example, a lambda of 10 means the option price is expected to increase by 10% if the underlying spot price increases by 1%.":
    "레버리지(람다)는 기초 스팟 가격이 1% 변동할 때 옵션 가격의 변동 비율을 나타냅니다.\n\n예를 들어, 람다가 10이면 기초 스팟 가격이 1% 상승할 때 옵션 가격이 10% 상승할 것으로 예상됩니다.",
  "Eight hour options funding rate that is continuously accrued on positions and settled upon any trade. The funding rate for perpetual options reflects both the cost of leverage and the cost of insurance against adverse price moves. \n\nThe funding period of perpetual options is 24 hours. This means that the option premium will be continuously paid out over a 24h period. 24h funding rate = 3 x 8h funding rate":
    "포지션에 지속적으로 발생하고 거래 시 정산되는 8시간 옵션 펀딩률. 영구 옵션의 펀딩률은 레버리지 비용과 불리한 가격 움직임에 대한 보험 비용을 모두 반영합니다.\n\n영구 옵션의 펀딩 기간은 24시간입니다. 이는 옵션 프리미엄이 24시간 동안 지속적으로 지급됨을 의미합니다. 24시간 펀딩률 = 3 x 8시간 펀딩률",
  "Risk": "리스크",
  "Vega": "베가",
  "Gamma": "감마",
  "Estimated Funding P&L for the next 8 hours based on current funding rates":
    "현재 펀딩률에 기반한 다음 8시간의 예상 펀딩 손익",
  "Vega represents the increase in option price based on a 1% increase in the implied volatility.\n\nFor example, a Vega of 5 means the price of the option is expected to increase by $5 for a 1% increase in the implied volatility.":
    "베가는 내재 변동성이 1% 상승할 때 옵션 가격의 상승을 나타냅니다.\n\n예를 들어, 베가가 5이면 내재 변동성이 1% 상승할 때 옵션 가격이 5달러 상승할 것으로 예상됩니다.",
  "Adjust Leverage": "레버리지 조정",
  "Leverage updated successfully": "레버리지가 성공적으로 업데이트되었습니다",
  "Failed to update leverage": "레버리지 업데이트 실패",
  "Adjust leverage parameters for selected market. Leverage will also increase on your open positions.":
    "선택한 시장의 레버리지 매개변수를 조정합니다. 오픈 포지션의 레버리지도 증가합니다.",
  "Please note that changing leverage will also apply for open positions and open orders on this market.":
    "레버리지 변경은 이 시장의 오픈 포지션과 오픈 주문에도 적용됩니다.",
  "Selecting higher leverage could result in Deleveraging where some of your open orders would be cancelled.":
    "더 높은 레버리지를 선택하면 일부 오픈 주문이 취소되는 디레버리징이 발생할 수 있습니다.",
  "disabled": "비활성화됨",
  "Margin Mode": "마진 모드",
  "Manage your risk on individual positions by restricting the amount of margin allocated to each. If the margin ratio of an isolated position reaches 100%, the position will be liquidated. Margin can be added or removed to individual positions in this mode.":
    "각 포지션에 할당되는 마진 금액을 제한하여 개별 포지션의 리스크를 관리합니다. 격리된 포지션의 마진 비율이 100%에 도달하면 포지션이 청산됩니다. 이 모드에서는 개별 포지션에 마진을 추가하거나 제거할 수 있습니다.",
  "Margin mode updated successfully":
    "마진 모드가 성공적으로 업데이트되었습니다",
  "Failed to update margin mode": "마진 모드 업데이트 실패",
  "Favorites": "즐겨찾기",
  "Trending": "인기",
  "Losers": "하락",
  "Gainers": "상승",
  "New Listing": "새로운 상장",
  "Developers": "개발자",
  "Developer Mode": "개발자 모드",
  "Enable developer mode": "개발자 모드 활성화",
  "For external use": "외부 사용",
  "Warning: Changing transfer behavior": "경고: 전송 동작 변경",
  "USDC will be transferred to account contract instead of Paradex. Amount won't be visible or available for use within Paradex, but can be used with external applications.":
    "USDC는 Paradex 대신 계정 계약에 전송됩니다. 금액은 Paradex 내에서는 보이지 않고 사용할 수 없지만 외부 애플리케이션에서 사용할 수 있습니다.",
  "Affiliate Dashboard": "관계사 대시보드",
  "Add TP/SL For This Order": "이 주문에 TP/SL 추가",
  "Take Profit Limit Price": "테이크 프로핏 지정가",
  "Stop Loss Limit Price": "스탑 로스 지정가",
  "Order Modification Submitted": "주문 수정이 제출되었습니다",
  "Order Modified Successfully": "주문이 성공적으로 수정되었습니다",
  "Order Modification Rejected": "주문 수정이 거부되었습니다",
  "Order Modification Unknown Status": "주문 수정 상태를 알 수 없습니다",
  "Order Modification Unknown Error":
    "주문 수정 중 알 수 없는 오류가 발생했습니다",
  "Updated At": "업데이트 시간",
  "Order Size": "주문 크기",
  "Last 7 Days": "지난 7일",
  "Last 14 Days": "지난 14일",
  "Last 30 Days": "지난 30일",
  "Last 90 Days": "지난 90일",
};

export default translations;
